
import { Watch, Mixins, Component, ProvideReactive } from "vue-property-decorator";
import ConsultationList from "./components/list.vue";
import ConsultationOrgan from "./components/organ.vue";


@Component({
  inject: [],
  components: { ConsultationList, ConsultationOrgan }
})
export default class ConsultationIndex extends Mixins() {
    @ProvideReactive() currentTab = "1";
}

